import { IEditMenuItemFormData } from '@/components-latest/ui/MenuPage/EditMenuItemModal'
import { IPackType } from '@/components-latest/ui/MenuPage/EditMenuItemModal/EditMenuItemAddons'
import { IEditMenuItemDTO } from '@/ducks/menu/api/menu.api.types'

const mapEditMenuPacksByCategories = (packs: {
  [packId: string]: { categoryId: string; price: number; visibility: number }
} = {}) => {
  return Object.entries(packs).reduce(
    (acc, [packId, pack]) => {
      if (!acc?.[pack.categoryId]) acc[pack.categoryId] = []

      acc[pack.categoryId].push({
        _id: packId,
        price: pack.price,
        visibility: pack.visibility as 0 | 1
      })

      return acc
    },
    {} as {
      [categoryId: string]: Array<{
        _id: string
        price: number
        visibility: 0 | 1
      }>
    }
  )
}

export const mapEditMenuItemDTO = (
  menuItemFormData: Partial<IEditMenuItemFormData>
): Partial<IEditMenuItemDTO> => {
  const {
    addons = {},
    type_pack = {},
    base_pack = {},
    price,
    food_name,
    maxQuantity,
    food_id
  } = menuItemFormData

  const result: Partial<IEditMenuItemDTO> = {}

  if (food_id !== undefined) {
    result.food_id = food_id
  }

  if (food_name !== undefined) {
    result.food_name = food_name
  }

  if (price !== undefined) {
    result.price = price
  }

  if (maxQuantity !== undefined) {
    result.maxQuantity = maxQuantity
  }

  if (Object.keys(addons).length > 0) {
    result.addons = Object.entries(addons).map(([addonId, addon]) => ({
      _id: addonId,
      price: addon.price
    }))
  }

  if (Object.keys(type_pack).length > 0) {
    const mappedTypePacksByCategory = mapEditMenuPacksByCategories(type_pack)
    result.type_pack = Object.entries(mappedTypePacksByCategory).map(
      ([packId, packs]) => ({
        _id: packId,
        t_sub_pack: packs.map(packItem => ({
          price: packItem.price,
          _id: packId
        }))
      })
    )
  }

  if (Object.keys(base_pack).length > 0) {
    const mappedBasePacksByCategory = mapEditMenuPacksByCategories(base_pack)
    result.base_pack = Object.entries(mappedBasePacksByCategory).map(
      ([packId, packs]) => ({
        _id: packId,
        sub_pack: packs.map(packItem => ({
          price: packItem.price,
          _id: packId
        }))
      })
    )
  }

  const visibilities = [
    ...Object.entries(addons).map(([addonId, { visibility }]) => ({
      extra: {
        _id: addonId,
        visibility,
        name: 'addons' as IPackType
      }
    })),
    ...Object.entries(type_pack).map(([packId, { visibility }]) => ({
      extra: {
        _id: packId,
        visibility,
        name: 'type_pack' as IPackType
      }
    })),
    ...Object.entries(base_pack).map(([packId, { visibility }]) => ({
      extra: {
        _id: packId,
        visibility,
        name: 'base_pack' as IPackType
      }
    }))
  ]

  if (visibilities.length > 0) {
    result.visibilities = visibilities
  }

  return result
}
